import { render, staticRenderFns } from "./SceneryRank.vue?vue&type=template&id=44d6c6b6&scoped=true&"
import script from "./SceneryRank.vue?vue&type=script&lang=js&"
export * from "./SceneryRank.vue?vue&type=script&lang=js&"
import style0 from "./SceneryRank.vue?vue&type=style&index=0&id=44d6c6b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d6c6b6",
  null
  
)

export default component.exports